<template>
  <div class="wrapper">
    <span>{{$t('txmis.accountReward.tradeConfig')}}</span>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="tab in tabList" :label="tab.levelName" :name="tab.levelType"></el-tab-pane>
    </el-tabs>
    <el-card class="box-card" v-for="(card,dex) in update.col.data" v-show="card.levelType == activeName">
      <div class="nav_list">
        <el-form-item :label="$t('txmis.accountReward.condition')">
          <p class="item_title">{{$t('txmis.accountReward.symbolType')}}</p>
          <p class="item_title">排除产品列表</p>
          <p class="item_title">产品列表</p>
          <p class="item_title">{{$t('txmis.accountReward.me')}}</p>
          <p class="item_title">{{$t('txmis.accountReward.direct')}}</p>
          <p class="item_title">{{$t('txmis.accountReward.indirect')}}</p>
          <p class="item_title">{{$t('txmis.accountReward.quantity')}}</p>
        </el-form-item>
      </div>
      <div class="text item" v-for="(item,index) in card.value">
        <div slot="header" class="clearfix">
          <div style="float: right">
            <el-button type="text" @click="addReward(card.value)">{{$t('txmis.bt.add')}}</el-button>
            <el-button v-if="card.value.length > 1" type="text" @click="delReward(card.value,index)">{{$t('txmis.bt.delete')}}</el-button>
          </div>
        </div>
        <div class="text item">
          <el-form-item :label="$t('txmis.accountReward.condition')+(index+1)">
            <el-select :multiple="true" style="width: 10%" v-model="item.productType" @change="productTypeChangeValue(item,index,1)">
              <el-option
                v-for="option in productOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value">
              </el-option>
            </el-select>
            <el-select :multiple="true" :collapse-tags="true" style="width: 10%" v-model="item.excludeSymbol" @change="productTypeChangeValue(item,index,2,excludeSymbolList)">
              <el-checkbox v-model="excludeCheckedList[activeName][index]" @change="excludeSymbolSelectAll(item,index,excludeSymbolList)">全选</el-checkbox>
              <el-option
                v-for="option in excludeSymbolList"
                :key="option.value"
                :label="option.label"
                :value="option.value">
              </el-option>
            </el-select>
            <el-select :multiple="true" :collapse-tags="true" style="width: 10%" v-model="item.symbol" @change="symbolChangeValue(item.symbol,index,symbolList[activeName][index])">
              <el-checkbox v-model="checkedList[activeName][index]" @change="selectAll(item,index,symbolList[activeName][index])">全选</el-checkbox>
              <el-option
                v-for="option in symbolList[activeName][index]"
                :key="option.value"
                :label="option.label"
                :value="option.value">
              </el-option>
            </el-select>
            <el-input-number controls-position="right" style="width: 10%" :min="0" v-model="item.me"></el-input-number>
            <el-input-number controls-position="right" style="width: 10%" :min="0" v-model="item.direct"></el-input-number>
            <el-input-number controls-position="right" style="width: 10%" :min="0" v-model="item.indirect"></el-input-number>
            <el-input-number controls-position="right" style="width: 10%" :min="0" v-model="item.quantity"></el-input-number>
          </el-form-item>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
    import URL from "@/views/newmis36/util/url";
    let codeList = [];
    export default {
        name: 'product',
        props:["update"],
        methods: {
            addReward(value,index){
                value.push({productType:[],excludeSymbol:[],symbol:[],me:0,direct:0,indirect:0,quantity:0});
                this.symbolList[this.activeName].push([]);
                this.checkedList[this.activeName][index] = false;
                this.excludeCheckedList[this.activeName][index] = false;
            },
            delReward(value,index){
                value.splice(index, 1);
                this.symbolList[this.activeName].splice(index, 1);
                this.checkedList[this.activeName].splice(index, 1);
                this.excludeCheckedList[this.activeName].splice(index, 1);
            },
            productTypeChangeValue(item,index,type,symbolList){
              if (type == 2){
                this.excludeSymbolChangeValue(item.excludeSymbol,index,symbolList);
              }
              this.changeSymbolOptionList(item,index);
            },
            changeSymbolOptionList(item,index){
              console.log("产品排列");
              this.symbolList[this.activeName][index] = [];
              let symbolCode = [];
              for (let i in codeList) {
                if (item.productType.includes(codeList[i].zone) && !symbolCode.includes(codeList[i].symbol) && !item.excludeSymbol.includes(codeList[i].symbol)){
                  if ('codeList' == codeList[i].symbol){
                    console.log(item.productType,item.excludeSymbol);
                  }
                  let symbol = {value:codeList[i].symbol,label:codeList[i].symbol}
                  this.symbolList[this.activeName][index].push(symbol);
                  symbolCode.push(codeList[i].symbol);
                }
              }
            },
            selectAll(item,index,symbolList){
              item.symbol = [];
              if (this.checkedList[this.activeName][index]){
                symbolList.map((data)=>{
                  item.symbol.push(data.value);
                });
              }else{
                item.symbol = [];
              }
              this.$forceUpdate();
              console.log(item.symbol);
            },
          symbolChangeValue(symbol,index,symbolList){
              if (symbol.length == symbolList.length && symbol.length > 0){
                this.checkedList[this.activeName][index] = true;
              }else{
                this.checkedList[this.activeName][index] = false;
              }
          },
          excludeSymbolChangeValue(symbol,index,symbolList){
            if (symbol.length == symbolList.length && symbol.length > 0){
              this.excludeCheckedList[this.activeName][index] = true;
            }else{
              this.excludeCheckedList[this.activeName][index] = false;
            }
          },
          excludeSymbolSelectAll(item,index,symbolList){
            item.excludeSymbol = [];
            if (this.excludeCheckedList[this.activeName][index]){
              symbolList.map((data)=>{
                item.excludeSymbol.push(data.value);
              });
            }else{
              item.excludeSymbol = [];
            }
            this.$forceUpdate();
            //console.log(item.excludeSymbol);
            this.changeSymbolOptionList(item,index);
          },
        },
        created(){
          this.$axios.get(URL.rebateActivity.symbols).then(res => {
            //console.log(res);
            codeList = res.result;
            this.excludeSymbolList = codeList.filter(v=>{
              return v.zone == 101;
            }).map(data => {
                return {value:data.symbol,label:data.symbol};
            });
            /*console.log(codeList);
            for (let i in codeList) {
              if(codeList[i].symbol == 'SANDUSDT'){
                console.log(codeList[i]);
              }
            }*/
          });
        },
        data () {
            return {
                checkedList:{"MIN":[false],"STD":[false],"PLA":[false]},
                excludeCheckedList:{"MIN":[false],"STD":[false],"PLA":[false]},
                tabList:[
                    {"levelName":"迷你","levelType":"MIN"},
                    {"levelName":"标准","levelType":"STD"},
                    {"levelName":"铂金","levelType":"PLA"},
                ],
                activeName:"MIN",
                symbolList:{"MIN":[],"STD":[],"PLA":[]},
                excludeSymbolList:[
                  /*{
                    value: 'AUDJPY',
                    label: "AUDJPY"
                  },
                  {
                    value: 'HKDCNH',
                    label: "HKDCNH"
                  },
                  {
                    value: 'EURUSD',
                    label: "EURUSD"
                  },*/
                ],
                productOptions: [
                    {
                        value: '2',
                        label: "外汇"
                    },
                    {
                        value: '1',
                        label: "贵金属"
                    },
                    {
                        value: '5',
                        label: "指数"
                    },
                    {
                        value: '4',
                        label: "商品"
                    },
                    /*{
                        value: '-1',
                        label: "不限产品"
                    },
                    {
                      value: '100',
                      label: "非虚拟币"
                    },*/
                    {
                        value: '6',
                        label: "货币"
                    },
                    {
                        value: '7',
                        label: "股票"
                    }
                ]
            }
        }
    }
</script>
<style scoped>
  .nav_list .item_title{
    display: inline-block;
    float: left;
    width: 10.5%;
  }
</style>

